import { FC } from "react";
import DbIcon from "designs/DesignB/components/icons";

/**
 * What a Design B vehicle grid shows when the filters leave nothing (1NOW-11132, restyled in
 * 1NOW-11175): a hairline panel, the line, and a Clear filters button. Same words as before,
 * so the renter hears the same thing in every design.
 */
const NoCarsMatch: FC<{ onClear: () => void }> = ({ onClear }) => (
  <div role="status" className="db-empty col-span-full">
    <span className="db-empty__icon">
      <DbIcon name="car" className="h-12 w-12" />
    </span>
    <p className="db-empty__h">No vehicles match your filters</p>
    <p className="db-empty__p">Clear a filter to see the rest of the fleet.</p>
    <button type="button" className="db-btn db-btn--primary mt-2" onClick={onClear}>
      Clear filters
    </button>
  </div>
);

export default NoCarsMatch;
